// Estallido breve de partículas al confirmar el envío del formulario.
// Canvas 2D puro (sin three.js): ~1s, se autodestruye, respeta reduced-motion.
const COLORS = ["#c6a15b", "#e8efea", "#3fa37e"];
const LIFE_MS = 950;

export function successBurst(el) {
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const rect = el.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const canvas = document.createElement("canvas");
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    Object.assign(canvas.style, {
        position: "fixed", inset: "0", width: "100%", height: "100%",
        pointerEvents: "none", zIndex: "9999",
    });
    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);

    const particles = Array.from({ length: 28 }, (_, i) => {
        const angle = (Math.PI * 2 * i) / 28 + Math.random() * 0.4;
        const speed = 2.2 + Math.random() * 3.4;
        return {
            x: cx, y: cy,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed - 1.2,
            r: 1.6 + Math.random() * 2.2,
            color: COLORS[i % COLORS.length],
        };
    });

    const start = performance.now();
    function frame(now) {
        const p = (now - start) / LIFE_MS;
        if (p >= 1) { canvas.remove(); return; }
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        const fade = 1 - p;
        for (const pt of particles) {
            pt.x += pt.vx;
            pt.y += pt.vy;
            pt.vy += 0.07; // gravedad leve
            pt.vx *= 0.985;
            ctx.globalAlpha = fade;
            ctx.fillStyle = pt.color;
            ctx.beginPath();
            ctx.arc(pt.x, pt.y, pt.r * fade + 0.4, 0, Math.PI * 2);
            ctx.fill();
        }
        requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
}
